
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33860',
  depVersions: {
  "documents-public-ui": "static-1.33860",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33865",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1880",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5346",
  "hs-test-utils": "static-1.7761",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11177",
  "I18n": "static-7.1558",
  "jasmine-immutable": "static-1.2774",
  "jasmine-runner": "static-1.6229",
  "lodash": "static-1.3",
  "quartz": "static-1.6669",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16396",
  "reporting-data": "static-1.66331",
  "reporting-testing-lib": "static-1.8264",
  "reporting-visualizations": "static-1.58407",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4521",
  "webpack-env": "static-1.54",
  "atom": "static-1.4826",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2241",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.719",
  "customer-data-filters-ui": "static-1.38723",
  "customer-data-objects": "static-1.7398",
  "customer-data-property-utils": "static-1.7827",
  "data-fetching-client": "static-1.9432",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4287",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85192",
  "FormUrlGenerator": "static-2.4486",
  "foundations-components": "static-1.7431",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11485",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6918",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3615",
  "property-translator": "static-1.5169",
  "quartz-config": "static-1.447",
  "quartz-core": "static-1.5888",
  "quick-fetch": "static-1.3692",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5136",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7915",
  "reference-resolvers-lite": "static-1.7845",
  "report-customization-components": "static-1.12366",
  "reporting-enablement": "static-1.21928",
  "reporting-reports": "static-1.66009",
  "reporting-snowflake": "static-1.54949",
  "reporting-ui-components": "static-2.63603",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4387",
  "sales-content-partitioning": "static-1.8690",
  "SalesContentIndexUI": "static-3.8835",
  "sanitize": "static-1.4230",
  "sanitize-text": "static-1.7895",
  "self-service-api": "static-1.9999",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1509",
  "signup-constants": "static-1.18299",
  "signup-ui-lego-core": "static-1.20309",
  "signup-ui-url-generator": "static-2.7817",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4527",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10750",
  "ui-addon-i18n": "static-1.10886",
  "ui-addon-react-router-dom": "static-1.9303",
  "ui-addon-upgrades": "static-9.17581",
  "ui-asset-management-lib": "static-1.10648",
  "ui-images": "static-2.1080",
  "UIComponents": "static-3.8124",
  "usage-tracker": "static-1.7089",
  "usage-tracker-container": "static-1.7079",
  "usage-tracker-core": "static-1.6939",
  "usage-tracker-public": "static-1.6900",
  "viral-links-lib": "static-1.6781",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3188",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2946",
  "quartz-webpack": "static-1.2893",
  "ai-components-ui-library": "static-1.8224",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4587",
  "foundations-theming": "static-1.4164",
  "quartz-auth": "static-1.344",
  "usage-tracker-session-replay": "static-1.4775",
  "foundations-theming-base": "static-1.3149",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2872",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4086",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7682",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3462",
  "reporting-client-types": "static-1.2369",
  "hs-story-utils": "static-1.9183",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9371",
  "hubspotter-http": "static-1.4440",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7004",
  "crm-message-bus": "static-1.42219",
  "customer-data-filters-ui-msw-helpers": "static-1.21157",
  "customer-data-objects-ui-components": "static-1.12758",
  "customer-data-reference-ui-components": "static-1.12896",
  "customer-data-ui-utilities": "static-1.9580",
  "framework-builder-read-service-client": "static-1.3809",
  "framework-data-schema-quick-fetch": "static-1.6529",
  "framework-data-schema-resolvers": "static-1.6624",
  "inbound-db-properties-service-client": "static-1.3639",
  "multi-account-reference-resolvers": "static-1.724",
  "onboarding-tours": "static-1.16197",
  "reporting-datasets-permissions-lib": "static-1.12919",
  "ui-addon-teams": "static-1.21178",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67494",
  "customer-data-properties": "static-1.50640",
  "forms-ai-lib": "static-1.3947",
  "forms-utils-lib": "static-1.12087",
  "foundations-components-test-utils": "static-1.4914",
  "react-dnd-compat": "static-1.4379",
  "react-tinymce": "static-1.54504",
  "tinymce-config": "static-2.53630",
  "ui-gdpr-components": "static-1.10102",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3700",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1074",
  "ui-fonts": "static-1.439",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-head": "static-1.334",
  "quartz-i18n": "static-1.344",
  "quartz-routing": "static-1.99",
  "quartz-test": "static-1.344",
  "batch-promise": "static-1.1305",
  "external-options-client-types": "static-1.3945",
  "react-colorpicker": "static-2.9967",
  "copilot-toolkit": "static-1.10410",
  "data-quality-ui-library": "static-1.12217",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40520",
  "reporting-insights-lib": "static-1.1035",
  "reporting-plugins": "static-1.9925",
  "ui-addon-draggable-compat": "static-2.4009",
  "ui-addon-opt": "static-4.8143",
  "ui-shepherd-react": "static-3.9900",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24603",
  "hubspot-apollo-client": "static-1.4634",
  "sales-templates-service-types-lib": "static-1.3955",
  "ui-business-units-lib": "static-1.8778",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5416",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3866",
  "upgrade-management-service-types": "static-1.4263",
  "timezone-utils": "static-2.4999",
  "bender-build-tools": "static-1.2886",
  "chatspot-core": "static-1.20140",
  "chirp-fetch": "static-1.1637",
  "bend-plugin-foundations-theming": "static-1.2647",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9369",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3585",
  "crm-pipelines-api-client-types": "static-1.3926",
  "multi-currency-client-types": "static-1.3480",
  "getting-started-shared-tasks": "static-1.17758",
  "growth-data-modal": "static-1.5109",
  "growth-onboarding-confetti": "static-1.2825",
  "growth-onboarding-next-action-utils": "static-1.1250",
  "navigation-components": "static-1.17124",
  "onboarding-tours-client": "static-1.4411",
  "onboarding-tours-utils": "static-1.263",
  "ui-shepherd-tracker": "static-1.7281",
  "ui-universal-auth": "static-1.8632",
  "user-context": "static-1.4850",
  "cms-field-types": "static-1.4562",
  "content-icons-ui": "static-1.2139",
  "integrations-lib": "static-1.15278",
  "calling-global-api": "static-1.63525",
  "calling-internal-common": "static-1.31047",
  "calling-lifecycle-internal": "static-1.64907",
  "calling-lifecycle-messages": "static-1.57201",
  "commerce-products-lib": "static-1.8715",
  "crm-links": "static-1.6008",
  "file-manager-components": "static-1.22752",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.426",
  "inbounddb-objects-service-types": "static-1.4012",
  "meetings-icalendar-utils-lib": "static-1.389",
  "object-builder-ui-client": "static-1.47828",
  "pipeline-validation-client-types": "static-1.3749",
  "property-value-citations": "static-1.1254",
  "pulse": "static-1.255",
  "smart-property-lib": "static-1.5721",
  "tiered-pricing": "static-1.762",
  "ui-addon-iframeable": "static-1.8796",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19398",
  "tinymce-themes": "static-1.55600",
  "data-token-picker": "static-1.15973",
  "hub-http-contrib": "static-1.2800",
  "interframe": "static-3.4547",
  "tinymce-data": "static-1.39715",
  "tinymce-plugins": "static-1.56744",
  "ui-addon-sales-email": "static-1.4968",
  "magpie-lib": "static-1.5349",
  "magpie-types": "static-1.4809",
  "simple-logging-lib": "static-1.2806",
  "content-assistance-lib": "static-1.7382",
  "dashboard-lib": "static-1.80436",
  "ExportDialog": "static-6.10143",
  "hubspot-prosemirror": "static-1.17482",
  "hubspot-prosemirror-plugins": "static-1.17474",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8445",
  "campaign-roi-lib": "static-1.8151",
  "feedback-loader": "static-1.28771",
  "onboarding-scopes": "static-1.6220",
  "apollo-link-hub-http": "static-2.4404",
  "hubspot-apollo-cache": "static-1.93",
  "growth-monetization-service-types": "static-1.4279",
  "nav-client-types": "static-1.2111",
  "purchase-motions-api": "static-1.5419",
  "trials-service-types": "static-1.3680",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.481",
  "getting-started-shared-tasks-store": "static-1.16876",
  "integrations-error-boundary-lib": "static-1.12693",
  "integrations-tracking-lib": "static-1.5339",
  "native-integrations-shared-strings": "static-1.7544",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10128",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31053",
  "shared-worker-versioning": "static-1.10793",
  "calling-usage-tracker": "static-1.6294",
  "voice-sms-access-library": "static-1.110",
  "customer-data-tracking": "static-1.6637",
  "products-iframe-lib": "static-1.7198",
  "products-ui-components-shared-msw-handlers": "static-1.9753",
  "location-customization-utils-lib": "static-1.8420",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3910",
  "video-components-external": "static-1.10448",
  "video-data-lib": "static-1.34106",
  "directed-graph": "static-1.692",
  "event-emitter": "static-1.703",
  "breeze-intelligence-kit": "static-1.5252",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9454",
  "fsm": "static-1.3487",
  "policy-lib": "static-1.6540",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9517",
  "navigation-messaging": "static-1.6451",
  "FileManagerLib": "static-1.38392",
  "NamespacedHubStyle": "static-2.8858",
  "FileManagerCore": "static-1.38251",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11953",
  "layout-dnd-utils": "static-1.10928",
  "react-codemirror": "static-1.10383",
  "ui-addon-emoji-picker": "static-1.9645",
  "ui-brand-identity-lib": "static-1.13659",
  "ui-addon-video-player": "static-1.8449",
  "ui-coaching-tips": "static-1.27828",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8322",
  "payment-link-components": "static-1.22816",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2961",
  "universal-page-editor-lib": "static-1.2754",
  "calling-orchestration-schema": "static-1.34887",
  "sales-views-client-types": "static-1.4049",
  "crm-record-cards-service-types": "static-1.3413",
  "content-media-composition-data-lib": "static-1.11296",
  "content-media-compositions": "static-2.15303",
  "media-bridge-lib": "static-1.18495",
  "trellis-story-utils": "static-1.4277",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5547",
  "FileManagerImages": "static-1.35903",
  "video-components": "static-1.12451",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4288",
  "video-embed": "static-1.34940",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67569",
  "layout-data-lib": "static-1.9253",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6340",
  "commerce-tours-lib": "static-1.5652",
  "growth-onboarding-reliability": "static-1.4844",
  "sales-checkout-service-client": "static-1.3432",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21236",
  "sales-email-signature-service-client": "static-1.3598",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21234",
  "outpost": "static-1.3963",
  "advanced-menus-core": "static-1.14751",
  "advanced-menus-lib": "static-1.11734",
  "ui-memberships-settings-lib": "static-1.33312",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14750",
  "simple-menus-lib": "static-1.16267"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33860",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33865",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1880",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5346",
  "hs-test-utils": "/hs-test-utils/static-1.7761",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11177",
  "I18n": "/I18n/static-7.1558",
  "jasmine-immutable": "/jasmine-immutable/static-1.2774",
  "jasmine-runner": "/jasmine-runner/static-1.6229",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6669",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16396",
  "reporting-data": "/reporting-data/static-1.66331",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8264",
  "reporting-visualizations": "/reporting-visualizations/static-1.58407",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4521",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4826",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2241",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.719",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38723",
  "customer-data-objects": "/customer-data-objects/static-1.7398",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7827",
  "data-fetching-client": "/data-fetching-client/static-1.9432",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4287",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85192",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4486",
  "foundations-components": "/foundations-components/static-1.7431",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11485",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6918",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3615",
  "property-translator": "/property-translator/static-1.5169",
  "quartz-config": "/quartz-config/static-1.447",
  "quartz-core": "/quartz-core/static-1.5888",
  "quick-fetch": "/quick-fetch/static-1.3692",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5136",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7915",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7845",
  "report-customization-components": "/report-customization-components/static-1.12366",
  "reporting-enablement": "/reporting-enablement/static-1.21928",
  "reporting-reports": "/reporting-reports/static-1.66009",
  "reporting-snowflake": "/reporting-snowflake/static-1.54949",
  "reporting-ui-components": "/reporting-ui-components/static-2.63603",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4387",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8690",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8835",
  "sanitize": "/sanitize/static-1.4230",
  "sanitize-text": "/sanitize-text/static-1.7895",
  "self-service-api": "/self-service-api/static-1.9999",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1509",
  "signup-constants": "/signup-constants/static-1.18299",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20309",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7817",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4527",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10750",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10886",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9303",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17581",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10648",
  "ui-images": "/ui-images/static-2.1080",
  "UIComponents": "/UIComponents/static-3.8124",
  "usage-tracker": "/usage-tracker/static-1.7089",
  "usage-tracker-container": "/usage-tracker-container/static-1.7079",
  "usage-tracker-core": "/usage-tracker-core/static-1.6939",
  "usage-tracker-public": "/usage-tracker-public/static-1.6900",
  "viral-links-lib": "/viral-links-lib/static-1.6781",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3188",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2946",
  "quartz-webpack": "/quartz-webpack/static-1.2893",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8224",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4587",
  "foundations-theming": "/foundations-theming/static-1.4164",
  "quartz-auth": "/quartz-auth/static-1.344",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4775",
  "foundations-theming-base": "/foundations-theming-base/static-1.3149",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2872",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4086",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7682",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3462",
  "reporting-client-types": "/reporting-client-types/static-1.2369",
  "hs-story-utils": "/hs-story-utils/static-1.9183",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9371",
  "hubspotter-http": "/hubspotter-http/static-1.4440",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7004",
  "crm-message-bus": "/crm-message-bus/static-1.42219",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21157",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12758",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12896",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9580",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3809",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6529",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6624",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3639",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.724",
  "onboarding-tours": "/onboarding-tours/static-1.16197",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12919",
  "ui-addon-teams": "/ui-addon-teams/static-1.21178",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67494",
  "customer-data-properties": "/customer-data-properties/static-1.50640",
  "forms-ai-lib": "/forms-ai-lib/static-1.3947",
  "forms-utils-lib": "/forms-utils-lib/static-1.12087",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4914",
  "react-dnd-compat": "/react-dnd-compat/static-1.4379",
  "react-tinymce": "/react-tinymce/static-1.54504",
  "tinymce-config": "/tinymce-config/static-2.53630",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10102",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3700",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1074",
  "ui-fonts": "/ui-fonts/static-1.439",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-head": "/quartz-head/static-1.334",
  "quartz-i18n": "/quartz-i18n/static-1.344",
  "quartz-routing": "/quartz-routing/static-1.99",
  "quartz-test": "/quartz-test/static-1.344",
  "batch-promise": "/batch-promise/static-1.1305",
  "external-options-client-types": "/external-options-client-types/static-1.3945",
  "react-colorpicker": "/react-colorpicker/static-2.9967",
  "copilot-toolkit": "/copilot-toolkit/static-1.10410",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12217",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40520",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1035",
  "reporting-plugins": "/reporting-plugins/static-1.9925",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4009",
  "ui-addon-opt": "/ui-addon-opt/static-4.8143",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9900",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24603",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4634",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3955",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8778",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5416",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3866",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4263",
  "timezone-utils": "/timezone-utils/static-2.4999",
  "bender-build-tools": "/bender-build-tools/static-1.2886",
  "chatspot-core": "/chatspot-core/static-1.20140",
  "chirp-fetch": "/chirp-fetch/static-1.1637",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2647",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9369",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3585",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3926",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3480",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17758",
  "growth-data-modal": "/growth-data-modal/static-1.5109",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2825",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1250",
  "navigation-components": "/navigation-components/static-1.17124",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4411",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.263",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7281",
  "ui-universal-auth": "/ui-universal-auth/static-1.8632",
  "user-context": "/user-context/static-1.4850",
  "cms-field-types": "/cms-field-types/static-1.4562",
  "content-icons-ui": "/content-icons-ui/static-1.2139",
  "integrations-lib": "/integrations-lib/static-1.15278",
  "calling-global-api": "/calling-global-api/static-1.63525",
  "calling-internal-common": "/calling-internal-common/static-1.31047",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64907",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57201",
  "commerce-products-lib": "/commerce-products-lib/static-1.8715",
  "crm-links": "/crm-links/static-1.6008",
  "file-manager-components": "/file-manager-components/static-1.22752",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.426",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4012",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.389",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47828",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3749",
  "property-value-citations": "/property-value-citations/static-1.1254",
  "pulse": "/pulse/static-1.255",
  "smart-property-lib": "/smart-property-lib/static-1.5721",
  "tiered-pricing": "/tiered-pricing/static-1.762",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8796",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19398",
  "tinymce-themes": "/tinymce-themes/static-1.55600",
  "data-token-picker": "/data-token-picker/static-1.15973",
  "hub-http-contrib": "/hub-http-contrib/static-1.2800",
  "interframe": "/interframe/static-3.4547",
  "tinymce-data": "/tinymce-data/static-1.39715",
  "tinymce-plugins": "/tinymce-plugins/static-1.56744",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4968",
  "magpie-lib": "/magpie-lib/static-1.5349",
  "magpie-types": "/magpie-types/static-1.4809",
  "simple-logging-lib": "/simple-logging-lib/static-1.2806",
  "content-assistance-lib": "/content-assistance-lib/static-1.7382",
  "dashboard-lib": "/dashboard-lib/static-1.80436",
  "ExportDialog": "/ExportDialog/static-6.10143",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17482",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17474",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8445",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8151",
  "feedback-loader": "/feedback-loader/static-1.28771",
  "onboarding-scopes": "/onboarding-scopes/static-1.6220",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4404",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.93",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4279",
  "nav-client-types": "/nav-client-types/static-1.2111",
  "purchase-motions-api": "/purchase-motions-api/static-1.5419",
  "trials-service-types": "/trials-service-types/static-1.3680",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.481",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16876",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12693",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5339",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7544",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10128",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31053",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10793",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6294",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.110",
  "customer-data-tracking": "/customer-data-tracking/static-1.6637",
  "products-iframe-lib": "/products-iframe-lib/static-1.7198",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9753",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8420",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3910",
  "video-components-external": "/video-components-external/static-1.10448",
  "video-data-lib": "/video-data-lib/static-1.34106",
  "directed-graph": "/directed-graph/static-1.692",
  "event-emitter": "/event-emitter/static-1.703",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5252",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9454",
  "fsm": "/fsm/static-1.3487",
  "policy-lib": "/policy-lib/static-1.6540",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9517",
  "navigation-messaging": "/navigation-messaging/static-1.6451",
  "FileManagerLib": "/FileManagerLib/static-1.38392",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8858",
  "FileManagerCore": "/FileManagerCore/static-1.38251",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11953",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10928",
  "react-codemirror": "/react-codemirror/static-1.10383",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9645",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13659",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8449",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27828",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8322",
  "payment-link-components": "/payment-link-components/static-1.22816",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2961",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2754",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34887",
  "sales-views-client-types": "/sales-views-client-types/static-1.4049",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3413",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11296",
  "content-media-compositions": "/content-media-compositions/static-2.15303",
  "media-bridge-lib": "/media-bridge-lib/static-1.18495",
  "trellis-story-utils": "/trellis-story-utils/static-1.4277",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5547",
  "FileManagerImages": "/FileManagerImages/static-1.35903",
  "video-components": "/video-components/static-1.12451",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4288",
  "video-embed": "/video-embed/static-1.34940",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67569",
  "layout-data-lib": "/layout-data-lib/static-1.9253",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6340",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5652",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4844",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3432",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21236",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3598",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21234",
  "outpost": "/outpost/static-1.3963",
  "advanced-menus-core": "/advanced-menus-core/static-1.14751",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11734",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33312",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14750",
  "simple-menus-lib": "/simple-menus-lib/static-1.16267"
}
};
